import {
  MenuItemsType,
  DropdownMenuItemType,
  SwapIcon,
  SwapFillIcon,
  EarnIcon,
  EarnFillIcon,
  MoreIcon,
  ChartIcon,
} from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { nftsBaseUrl } from 'views/Nft/market/constants'
import { perpLangMap } from 'utils/getPerpetualLanguageCode'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t'], languageCode?: string) => ConfigMenuItemsType[] = (t, languageCode) => [
  {
    label: t('Swap'),
    icon: SwapIcon,
    fillIcon: SwapFillIcon,
    href: '/swap',
    items: [],
  },
  {
    label: t('Liquidity'),
    icon: EarnIcon,
    fillIcon: EarnFillIcon,
    href: '/liquidity',
    items: [],
  },
  {
    label: t('Analytics'),
    icon: ChartIcon,
    fillIcon: ChartIcon,
    href: '/info',
    items: [],
  },
]

export default config
